/* tslint:disable:max-line-length */
import React from 'react';
import classNames from 'classnames';
import { IconTypeProps } from '../types';

export const SyncIcon = ({
  className,
  style: propStyles,
  color = '#3A50F3',
  onClick,
  size,
  version = '1',
}: IconTypeProps & { version?: '1' | '2' }) => {
  const style = {
    width: `${size}px`,
    height: `${size}px`,
    ...propStyles,
  };

  if (version === '2') {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={style}
        className={classNames(className)}
        onClick={onClick}
      >
        <path
          d="M2.62455 7.87813C2.64018 7.19531 2.7808 6.53281 3.04486 5.90938C3.31518 5.26875 3.70268 4.69531 4.19643 4.2C4.69018 3.70469 5.26518 3.31719 5.9058 3.04688C6.5683 2.76719 7.27143 2.625 7.99799 2.625C8.72455 2.625 9.42768 2.76719 10.0886 3.04688C10.7274 3.31663 11.3075 3.70831 11.7964 4.2C11.9511 4.35469 12.0964 4.51875 12.2308 4.69063L11.2902 5.425C11.2716 5.4394 11.2574 5.45875 11.2493 5.48085C11.2412 5.50294 11.2395 5.52687 11.2444 5.54988C11.2493 5.5729 11.2606 5.59406 11.277 5.61094C11.2934 5.62783 11.3142 5.63974 11.3371 5.64531L14.0824 6.31719C14.1605 6.33594 14.2371 6.27656 14.2371 6.19688L14.2496 3.37031C14.2496 3.26562 14.1292 3.20625 14.048 3.27187L13.1667 3.96094C11.9652 2.42344 10.0964 1.4375 7.99643 1.4375C4.41674 1.4375 1.50424 4.30625 1.43705 7.87187C1.43663 7.88855 1.43956 7.90514 1.44565 7.92067C1.45175 7.9362 1.46089 7.95035 1.47254 7.96229C1.48419 7.97423 1.49811 7.98372 1.51348 7.9902C1.52886 7.99667 1.54537 8.00001 1.56205 8H2.49955C2.5683 8 2.62299 7.94531 2.62455 7.87813ZM14.4371 8H13.4996C13.4308 8 13.3761 8.05469 13.3746 8.12187C13.3589 8.80469 13.2183 9.46719 12.9542 10.0906C12.6839 10.7312 12.2964 11.3063 11.8027 11.8C11.3043 12.3004 10.7118 12.6972 10.0594 12.9675C9.40688 13.2379 8.70736 13.3763 8.00111 13.375C7.2951 13.3763 6.59582 13.2378 5.94361 12.9675C5.2914 12.6972 4.69918 12.3004 4.20111 11.8C4.04643 11.6453 3.90111 11.4812 3.76674 11.3094L4.70736 10.575C4.72597 10.5606 4.74014 10.5412 4.74824 10.5192C4.75634 10.4971 4.75804 10.4731 4.75314 10.4501C4.74825 10.4271 4.73695 10.4059 4.72056 10.3891C4.70417 10.3722 4.68335 10.3603 4.66049 10.3547L1.91518 9.68281C1.83705 9.66406 1.76049 9.72344 1.76049 9.80313L1.74955 12.6313C1.74955 12.7359 1.86986 12.7953 1.95111 12.7297L2.83236 12.0406C4.03393 13.5766 5.90268 14.5625 8.00268 14.5625C11.5839 14.5625 14.4949 11.6922 14.5621 8.12813C14.5625 8.11145 14.5595 8.09486 14.5534 8.07933C14.5474 8.0638 14.5382 8.04965 14.5266 8.03771C14.5149 8.02577 14.501 8.01628 14.4856 8.0098C14.4702 8.00333 14.4537 7.99999 14.4371 8Z"
          fill="#262626"
        />
      </svg>
    );
  }

  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      className={classNames(className)}
      onClick={onClick}
    >
      <g clipPath="url(#clip0)">
        <path
          d="M4.125 8.25L0.75 11.625C0.45 11.625 0.375 9.125 0.375 7.875H3C3.9 7.875 4.125 8.125 4.125 8.25Z"
          fill="white"
        />
        <path
          d="M11.25 0.375L7.875 3.75L11.625 4.125L11.25 0.375Z"
          fill="white"
        />
        <path
          d="M10.7197 0.220197L9.54558 1.39446C8.56432 0.637947 7.33484 0.187689 6 0.187689C2.88816 0.187689 0.347438 2.63311 0.194766 5.70706C0.18682 5.86685 0.31582 6.00019 0.475805 6.00019H0.710531C0.859406 6.00019 0.983508 5.8842 0.991242 5.73551C1.12873 3.0919 3.3138 0.984564 6 0.984564C7.11455 0.984564 8.14423 1.34813 8.97703 1.96308L7.72043 3.21985C7.24934 3.69094 7.5832 4.50019 8.25075 4.50019H11.25C11.6642 4.50019 12 4.1644 12 3.75019V0.750541C12 0.0831578 11.1899 -0.25003 10.7197 0.220197ZM11.25 3.75019H8.25L11.25 0.750189V3.75019ZM11.5242 6.00019H11.2895C11.1406 6.00019 11.0165 6.11618 11.0088 6.26487C10.8713 8.9112 8.68369 11.0158 6 11.0158C4.88613 11.0158 3.85622 10.6523 3.02306 10.0371L4.27959 8.78051C4.75066 8.30942 4.41682 7.50019 3.74927 7.50019H0.75C0.335789 7.50019 0 7.83598 0 8.25019V11.2497C0 11.9203 0.811289 12.2491 1.28032 11.78L2.45435 10.6059C3.43563 11.3624 4.66514 11.8127 6 11.8127C9.11187 11.8127 11.6526 9.36727 11.8052 6.29332C11.8132 6.13353 11.6842 6.00019 11.5242 6.00019ZM0.75 11.2502V8.25019H3.75L0.75 11.2502Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
